import React, {useEffect, useRef, useState} from "react";
import imageCarne from "@/assets/1 Carne.jpg";
import imageLactate from "@/assets/2 Lactate.jpg";
import imageBauturiAlcoolice from "@/assets/5 Bauturi cu alcool.jpg";
import imageIgienaCasei from "@/assets/6 Detergenti igienizarea casei.jpg";
import imageFrumusete from "@/assets/7 Frumusete.jpg";
import imageTextile from "@/assets/12 Textile.jpg";
import imageServiciiComp from "@/assets/14 Servicii complementare.jpg";
import imageBrutarie from "@/assets/22 Brutarie patiserie cofetarie.jpg";
import imageGastro from "@/assets/23 Gastro.jpg";
import imageFructeLegume from "@/assets/25 Fructe si legume.jpg";
import imageBranzeturi from "@/assets/27 Branzeturi.jpg";
import imageMezeluri from "@/assets/28 Mezeluri.jpg";
import imageCongelate from "@/assets/29 Congelate.jpg";
import imageSarate from "@/assets/30 Sarate.jpg";
import imageDulciuri from "@/assets/31 Dulciuri.jpg";
import imageBauturiNonAlcoolice from "@/assets/34 Bauturi fara alcool.jpg";
import imageAlimentSpeciala from "@/assets/37 Alimentatie speciala.jpg";
import imageAnimalier from "@/assets/37 Animalier.jpg";
import imageBebe from "@/assets/38 Bebe.jpg";
import imageMenaj from "@/assets/41 Menaj.jpg";
import imageAuto from "@/assets/42 Auto brico.jpg";
import imageCultura from "@/assets/43 Cultura jocuri jucarii.jpg";
import imageActivitati from "@/assets/44 Activitati exterioare.jpg";
import {useParams} from "react-router-dom";
import {ProductsListResponse} from "@/api/ArticlesAPI";
import {TableBody, TableCell, TableRow,} from "@/components/ui/table"
import {ArticleModel} from "@/api/Models";
import {mapArticleModelToProductData} from "../Cart/cart.dto";
import ProductTable from "../ProductCard/ProductTable";
import {toast} from "../ui/use-toast";
import Navbar from "../Navbar/Navbar";
import noImageAvailable from "@/assets/images.png";
import ApiHttpClient from "@/HttpClient";
import {useLanguage} from "../Navbar/LanguageContext";
import Footer from "@/components/Footer/Footer";
import imagePeste from "@/assets/3 Peste.png";
import {useCheckUserUM} from "../utils/useCheckUserUM";
import {getDecodedTokenDetails} from "@/components/Token/TokenService";
import imageServicii from "@/assets/Piata 49 SERVICII.jpg";
import imageElectrocasnice from "@/assets/Piata 11 ELECTROCASNICE.jpg";
import imageElectronice from "@/assets/Piata 9 ELECTRONICE,MULTIMEDIA.jpg";
import LoadingElement from "@/components/Loading/LoadingElement";
import {BiSolidGridAlt} from "react-icons/bi";
import {CiViewTable} from "react-icons/ci";
import ProductCard from "@/components/ProductCard/ProductCard";


const SearchInput: React.FC<any> = ({setSearchArticle}) => {
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        if (e.target.value.toLocaleLowerCase().length > 2) {
            setSearchArticle(e.target.value.toLowerCase());
        } else {
            setSearchArticle("");
        }
    };

    return (
        <input
            className="block w-full rounded-lg border border-gray-200 p-3 text-gray-600 hover:border-black"
            type="search"
            onChange={handleChange}
            placeholder="Cauta numele unui produs..."
        />
    );
};

function CategoryList() {
    const queryParams = useParams();
    const localMarketId = Number(queryParams.localMarketId);
    const [data, setData] = useState<ProductsListResponse>();
    const {language} = useLanguage();
    const pageSize = 50;
    const [isMultiple, setIsMultiply] = useState(false);
    const [isTabular, setIsTabular] = useState(true);
    const [openIndex, setOpenIndex] = useState<number | null>(null);
    const [currentPage, setCurrentPage] = useState(0);
    const [searchArticle, setSearchArticle] = useState("");
    const [selectedSegments, setSelectedSegments] = useState<number[]>([]);
    const [selectedSegmentCategories, setSelectedSegmentCategories] = useState<number[]>([]);
    const [userUM, setUserUM] = useState<boolean | null>(null);
    const [atacFlowUser, setAtacFlowUser] = useState(false);
    const [loading, setLoading] = useState<boolean>(false);
    const [segmentCategories, setSegmentCategories] = useState<{
        [segmentId: number]: { categoryId: number, categoryLabel: string }[]
    }>({});
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const [categoryFamilies, setCategoryFamilies] = useState<{
        [categoryId: number]: { familyId: number, familyLabel: string, categoryId: number }[]
    }>({});

    const [selectedFamilies, setSelectedFamilies] = useState<{
        [categoryId: number]: number[];
    }>({});

    useCheckUserUM((value: boolean) => setUserUM(value));

    const [articlesStock, setArticlesStock] = useState(false);
    const [articlesTransit, setArticlesTransit] = useState(false);

    const [possibleCategoriesForSegment, setPossibleCategoriesForSegment] = useState<any>([]);
    const [possibleFamiliesForCategory, setPossibleFamiliesForCategory] = useState<any>([]);

    const prevSelectedSegments = useRef<number[] | undefined>(undefined);
    const prevSelectedSegmentCategories = useRef<number[] | undefined>(undefined);

    const [inputValue, setInputValue] = useState(currentPage + 1);
    const [debounceTimer, setDebounceTimer] = useState<NodeJS.Timeout | null>(null);

    const categories = [
        // {
        //   id: 1,
        //   name: "PRODUSE AUCHAN",
        //   image: imageProduseAuchan,
        //   localMarketId: 6,
        // },
        {
            id: 2,
            name: "GASTRO",
            image: imageGastro,
            localMarketId: 23,
            subcategories: [
                {
                    segmentId: 707,
                    segmentName: "Gastro Productie Proprie"
                },
                {
                    segmentId: 708,
                    segmentName: "Gastro Semipreparate"
                },
            ]
        },
        {
            id: 3,
            name: "CARNE",
            image: imageCarne,
            localMarketId: 1,
            subcategories: [
                {
                    segmentId: 115,
                    segmentName: "Carmangerie"
                },
                {
                    segmentId: 120,
                    segmentName: "Pasare"
                },
                {
                    segmentId: 125,
                    segmentName: "Carne Congelata"
                }
            ]
        },
        {
            id: 4,
            name: "BRANZETURI",
            image: imageBranzeturi,
            localMarketId: 27,
            subcategories: [
                {
                    segmentId: 718,
                    segmentName: "Branzeturi cu Servire"
                },
                {
                    segmentId: 719,
                    segmentName: "Branzeturi cu Autoservire"
                },
            ]
        },
        {
            id: 5,
            name: "CONGELATE",
            image: imageCongelate,
            localMarketId: 29,
            subcategories: [
                {
                    segmentId: 723,
                    segmentName: "Inghetata Desert Congelat"
                },
                {
                    segmentId: 724,
                    segmentName: "Semipreparate Congelate"
                },
            ]
        },
        {
            id: 6,
            name: "PESTE",
            image: imagePeste,
            localMarketId: 3,
            subcategories: [
                {
                    segmentId: 240,
                    segmentName: "Peste Proaspat"
                },
                {
                    segmentId: 245,
                    segmentName: "Peste Procesat"
                },
            ]
        },
        {
            id: 7,
            name: "SARATE",
            image: imageSarate,
            localMarketId: 30,
            subcategories: [
                {
                    segmentId: 725,
                    segmentName: "Garnituri"
                },
                {
                    segmentId: 726,
                    segmentName: "Conserve"
                },
                {
                    segmentId: 727,
                    segmentName: "Condimente si Sosuri"
                },
                {
                    segmentId: 728,
                    segmentName: "Ulei si Otet"
                },
                {
                    segmentId: 729,
                    segmentName: "Aperitiv Sarat"
                },
            ]
        },
        {
            id: 8,
            name: "LACTATE",
            image: imageLactate,
            localMarketId: 2,
            subcategories: [
                {
                    segmentId: 155,
                    segmentName: "Unt si Margarina"
                },
                {
                    segmentId: 160,
                    segmentName: "Iaurt si Desert"
                },
                {
                    segmentId: 165,
                    segmentName: "Oua"
                },
                {
                    segmentId: 170,
                    segmentName: "Lactate UHT"
                },
                {
                    segmentId: 817,
                    segmentName: "Lactate Ultraproaspete"
                }
            ]
        },
        {
            id: 9,
            name: "MEZELURI",
            image: imageMezeluri,
            localMarketId: 28,
            subcategories: [
                {
                    segmentId: 720,
                    segmentName: "Masline si Antipasti"
                },
                {
                    segmentId: 721,
                    segmentName: "Mezeluri Stand cu Servire"
                },
                {
                    segmentId: 722,
                    segmentName: "Mezeluri Autoservire"
                },
            ]
        },
        {
            id: 10,
            name: "FRUCTE SI LEGUME",
            image: imageFructeLegume,
            localMarketId: 25,
            subcategories: [
                {
                    segmentId: 711,
                    segmentName: "Legume Proaspete"
                },
                {
                    segmentId: 712,
                    segmentName: "Fructe Proaspete"
                },
            ]
        },
        {
            id: 11,
            name: "BAUTURI FARA ALCOOL",
            image: imageBauturiNonAlcoolice,
            localMarketId: 34,
            subcategories: [
                {
                    segmentId: 739,
                    segmentName: "Apa"
                },
                {
                    segmentId: 740,
                    segmentName: "Bauturi Necarbo si Sirop"
                },
                {
                    segmentId: 741,
                    segmentName: "Bauturi Carbonatate"
                }
            ]
        },
        {
            id: 12,
            name: "DULCIURI",
            image: imageDulciuri,
            localMarketId: 31,
            subcategories: [
                {
                    segmentId: 730,
                    segmentName: "Desert"
                },
                {
                    segmentId: 731,
                    segmentName: "Biscuiti Patiserie"
                },
                {
                    segmentId: 732,
                    segmentName: "Mic Dejun"
                },
                {
                    segmentId: 733,
                    segmentName: "Bauturi Calde"
                },
                {
                    segmentId: 734,
                    segmentName: "Bomboane si Ciocolata"
                },
            ],

        },
        {
            id: 13,
            name: "ALIMENTATIE SPECIALA",
            image: imageAlimentSpeciala,
            localMarketId: 32,
            subcategories: [
                {
                    segmentId: 737,
                    segmentName: "Specialit Internationale"
                },
            ]
        },
        {
            id: 14,
            name: "FRUMUSETE",
            image: imageFrumusete,
            localMarketId: 7,
            subcategories: [
                {
                    segmentId: 395,
                    segmentName: "Frumusete"
                },
                {
                    segmentId: 400,
                    segmentName: "Intretinere Par"
                },
                {
                    segmentId: 405,
                    segmentName: "Igiena"
                },
                {
                    segmentId: 410,
                    segmentName: "Machiaj"
                }
            ]
        },
        {
            id: 15,
            name: "BAUTURI CU ALCOOL",
            image: imageBauturiAlcoolice,
            localMarketId: 5,
            subcategories: [
                {
                    segmentId: 340,
                    segmentName: "Bauturi Spirtoase"
                },
                {
                    segmentId: 345,
                    segmentName: "Bere"
                },
                {
                    segmentId: 355,
                    segmentName: "Vin"
                }
            ]
        },
        {
            id: 16,
            name: "BRUTARIE PATISERIE COFETARIE",
            image: imageBrutarie,
            localMarketId: 22,
            subcategories: [
                {
                    segmentId: 704,
                    segmentName: "Panificatie Prod Proprie"
                },
                {
                    segmentId: 705,
                    segmentName: "Patiserie Prod Proprie"
                },
                {
                    segmentId: 706,
                    segmentName: "Cofetarie Prod Proprie"
                },
            ]
        },
        {
            id: 17,
            name: "ANIMALIER",
            image: imageAnimalier,
            localMarketId: 37,
            subcategories: [
                {
                    segmentId: 746,
                    segmentName: "Animalier"
                },
            ]
        },
        {
            id: 18,
            name: "DETERGENTI IGIENIZAREA CASEI",
            image: imageIgienaCasei,
            localMarketId: 6,
            subcategories: [
                {
                    segmentId: 385,
                    segmentName: "Spalare/Intretinere"
                },
                {
                    segmentId: 390,
                    segmentName: "Igienizarea Casei"
                },
                {
                    segmentId: 851,
                    segmentName: "Hartie Uz Casnic"
                }
            ]
        },
        {
            id: 19,
            name: "BEBE",
            image: imageBebe,
            localMarketId: 38,
            subcategories: [
                {
                    segmentId: 747,
                    segmentName: "Alimente Bebelusi"
                },
                {
                    segmentId: 748,
                    segmentName: "Igiena Bebe"
                },
            ]
        },
        {
            id: 20,
            name: "MENAJ",
            image: imageMenaj,
            localMarketId: 41,
            subcategories: [
                {
                    segmentId: 757,
                    segmentName: "Curatenia si Intret Casei"
                },
                {
                    segmentId: 758,
                    segmentName: "Decorarea Casei"
                },
                {
                    segmentId: 759,
                    segmentName: "Aranjarea Mesei"
                },
                {
                    segmentId: 760,
                    segmentName: "Articole de Gatit"
                },
            ]
        },
        {
            id: 21,
            name: "CULTURA JOCURI JUCARII",
            image: imageCultura,
            localMarketId: 43,
            subcategories: [
                {
                    segmentId: 763,
                    segmentName: "Papetarie"
                },
            ]
        },
        {
            id: 22,
            name: "TEXTILE",
            image: imageTextile,
            localMarketId: 12,
            subcategories: [
                {
                    segmentId: 534,
                    segmentName: "Lenjerie Barbati"
                },
                {
                    segmentId: 535,
                    segmentName: "Lenjerie Femei"
                },
            ]
        },
        {
            id: 23,
            name: "AUTO BRICO",
            image: imageAuto,
            localMarketId: 42,
            subcategories: [
                {
                    segmentId: 761,
                    segmentName: "Auto"
                },
                {
                    segmentId: 762,
                    segmentName: "Bricolaj"
                },
            ]
        },
        {
            id: 24,
            name: "ACTIVITATI EXTERIOARE",
            image: imageActivitati,
            localMarketId: 44,
            subcategories: [
                {
                    segmentId: 766,
                    segmentName: "Gradina"
                },
            ]
        },
        {
            id: 25,
            name: "SACOSE",
            image: imageServiciiComp,
            localMarketId: 14,
            subcategories: [
                {
                    segmentId: 671,
                    segmentName: "Sacose"
                },
            ]
        },
        {
            id: 26,
            name: "ELECTRONICE MULTIMEDIA",
            image: imageElectronice,
            localMarketId: 9,
            subcategories: [
                {
                    segmentId: 482,
                    segmentName: "Sunet"
                },
                {
                    segmentId: 483,
                    segmentName: "Accesorii Imagine/Sunet"
                },
                {
                    segmentId: 486,
                    segmentName: "IT Accesorii"
                },
                {
                    segmentId: 487,
                    segmentName: "Foto"
                },
                {
                    segmentId: 488,
                    segmentName: "Telefonie"
                },
            ]
        },
        {
            id: 26,
            name: "ELECTROCASNICE",
            image: imageElectrocasnice,
            localMarketId: 11,
            subcategories: [
                {
                    segmentId: 526,
                    segmentName: "Electrocasnice mari"
                },
                {
                    segmentId: 527,
                    segmentName: "Electrocasnice mici"
                },
            ]
        },
        {
            id: 27,
            name: "SERVICII",
            image: imageServicii,
            localMarketId: 49,
            subcategories: [
                
            ]
        },
    ];

    const toggleDropdown = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const handlePageChange = (selectedPage: number) => {
        setCurrentPage(selectedPage);
    };

    const showMultiply = () => {
        setIsMultiply(true);
        setIsTabular(false);
    };

    const showTable = () => {
        setIsTabular(true);
        setIsMultiply(false);
    };

    const handleSegmentFilter = (segmentId: number) => {
        const isSelected = selectedSegments.includes(segmentId);
        let newSelectedSegments;

        if (isSelected) {
            newSelectedSegments = selectedSegments.filter(id => id !== segmentId);

            setSegmentCategories(prev => {
                const copy = { ...prev };
                const removedCategories = copy[segmentId]?.map(c => c.categoryId) || [];
                
                setSelectedFamilies(prevFam => {
                    const updatedFam: typeof prevFam = {};
                    Object.entries(prevFam).forEach(([catId, famIds]) => {
                        if (!removedCategories.includes(Number(catId))) {
                            updatedFam[Number(catId)] = famIds;
                        }
                    });
                    return updatedFam;
                });
                
                setSelectedCategories(prevCats =>
                    prevCats.filter(
                        catId => !removedCategories.includes(catId)
                    )
                );
                
                delete copy[segmentId];
                return copy;
            });
            
            setCategoryFamilies(prev => {
                const updated = { ...prev };
                const removedCategories =
                    segmentCategories[segmentId]?.map(c => c.categoryId) || [];

                removedCategories.forEach(catId => {
                    delete updated[catId];
                });

                return updated;
            });

        } else {
            newSelectedSegments = [...selectedSegments, segmentId];
            fetchCategoriesBySegment(segmentId);
        }

        setSelectedSegments(newSelectedSegments);
    };


    useEffect(() => {
        if (data?.items && data.items.length > 0) {
            getFamiliesBySelectedCategories(selectedCategories, data.items);
        }
    }, [selectedCategories, data?.items]);



    // const resetFilters = () => {
    //     setSelectedSegments([]);
    // };

    // const resetFiltersSegmentCategories = () => {
    //     setSelectedSegmentCategories([]);
    // };

   
    // const resetFiltersFamilies = () => {
    //     setSelectedFamilies([]);
    // };

    useEffect(() => {
        (async () => {
            const tokenDetails = await getDecodedTokenDetails();

            if (tokenDetails?.token) {
                try {
                    const userAtacFlow = tokenDetails.atacFlow;
                    setAtacFlowUser(userAtacFlow);
                } catch (error) {
                    console.error('Failed to decode token', error);
                }
            } else {
                console.error('No token found');
            }
        })();
    }, []);

    const getCategoriesBySelectedSegments = (paramSelectedSegments: number[], products: any[]) => {
        const possibleCategories = products.filter(item =>
            paramSelectedSegments.includes(item.localSegmentId)
        ).map(item => ({
            categoryId: item.localCategoryId,
            categoryLabel: item.categoryLabel,
            segmentId: item.localSegmentId,
            segmentLabel: item.segmentLabel
        }));

        setPossibleCategoriesForSegment(possibleCategories);
    };

    const getFamiliesBySelectedCategories = (paramSelectedCategories: number[], products: any[]) => {
        const possibleFamilies = products.filter(item =>
            paramSelectedCategories.includes(item.localCategoryId)
        ).map(item => ({
            familyId: item.localFamilyId,
            familyLabel: item.familyLabel,
            categoryId: item.localCategoryId,
            categoryLabel: item.categoryLabel,
        }));

        setPossibleFamiliesForCategory(possibleFamilies);
    };

    useEffect(() => {
        setInputValue(currentPage + 1);
    }, [currentPage]);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = Number(e.target.value);

        if (data?.totalPages && value > data.totalPages) {
            value = data.totalPages;
        } else if (value < 1) {
            value = 1;
        }
        setInputValue(value);

        if (debounceTimer) clearTimeout(debounceTimer);

        const timer = setTimeout(() => {
            if (data?.totalPages && value >= 1 && value <= data?.totalPages) {
                handlePageChange(value - 1);
            }
        }, 500);

        setDebounceTimer(timer);
    };
    
    useEffect(() => {
        let response;
        const updateProducts = async () => {
            if (
                selectedSegments.length === 0 &&
                selectedCategories.length === 0 &&
                Object.values(selectedFamilies).flat().length === 0 &&
                !searchArticle
            )
            
            setLoading(true);

            let filters = {
                "advancedFilter": {
                    "field": "marketId",
                    "operator": "eq",
                    "value": Number(localMarketId)
                },
                "pageNumber": currentPage + 1,
                "pageSize": pageSize,
            } as any;

            if (selectedSegments.length > 0) {
                filters.advancedFilter = {
                    "logic": "and",
                    "filters": [
                        {
                            "filters": selectedSegments.map(segment =>
                                ({
                                    field: "segmentId",
                                    operator: "eq",
                                    value: Number(segment)
                                })
                            ),
                            "logic": "or",
                        }
                    ],
                    "field": "marketId",
                    "operator": "eq",
                    "value": Number(localMarketId)
                };
            }

            if (selectedSegments.length > 0 && selectedCategories.length > 0) {
                filters.advancedFilter = {
                    "logic": "and",
                    "filters": [
                        {
                            "filters": selectedSegments.map(segment =>
                                ({
                                    field: "segmentId",
                                    operator: "eq",
                                    value: Number(segment)
                                })
                            ),
                            "logic": "or",
                        },
                        {
                            "filters": selectedCategories.map(category =>
                                ({
                                    field: "categoryId",
                                    operator: "eq",
                                    value: Number(category)
                                })
                            ),
                            "logic": "or",
                        }
                    ],
                    "field": "marketId",
                    "operator": "eq",
                    "value": Number(localMarketId)
                };
            }
            const hasSelectedFamilies = Object.values(selectedFamilies).some(famArr => famArr.length > 0);

            if (selectedSegments.length > 0 && selectedCategories.length > 0 && hasSelectedFamilies) {
                filters.advancedFilter = {
                    logic: "and",
                    filters: [
                        {
                            filters: selectedSegments.map(segment => ({
                                field: "segmentId",
                                operator: "eq",
                                value: Number(segment)
                            })),
                            logic: "or"
                        },
                        {
                            filters: selectedCategories.map(category => ({
                                field: "categoryId",
                                operator: "eq",
                                value: Number(category)
                            })),
                            logic: "or"
                        },
                    ],
                    field: "marketId",
                    operator: "eq",
                    value: Number(localMarketId)
                };
            }

            const allSelectedFamilies = Object.values(selectedFamilies).flat();

            if (allSelectedFamilies.length > 0) {
                if (!filters.advancedFilter.filters) {
                    filters.advancedFilter.filters = [];
                }

                filters.advancedFilter.filters.push({
                    filters: allSelectedFamilies.map(familyId => ({
                        field: "familyId",
                        operator: "eq",
                        value: Number(familyId)
                    })),
                    logic: "or"
                });
            }

            if (articlesStock || articlesTransit) {
                if (filters.advancedFilter.filters === undefined || filters.advancedFilter.filters === null) {
                    filters.advancedFilter.filters = [];
                }

                if (filters.advancedFilter.logic === undefined || filters.advancedFilter.logic === null) {
                    filters.advancedFilter.logic = "and";
                }

                filters.advancedFilter.filters.push({
                    field: "flowType",
                    operator: "eq",
                    value: articlesTransit ? "TR" : "ST"
                });
            }

            if (searchArticle) {
                setCurrentPage(0);
                filters.advancedSearch = {
                    "fields": [
                        "longName",
                        "longNameWeb",
                        'longNameEsl',
                        'longNameFr',
                        "articleId"
                    ],
                    "keyword": searchArticle
                };
            }

            response = await ApiHttpClient().post<ProductsListResponse>(
                `/articleAvailableForWorkingPoint/search`,
                filters
            );

            if (!response?.data) {
                toast({description: "A aparut o eroare pentru afisarea articolelor"});
                setLoading(false);
                return <></>;
            }

            setData(response.data);
            setLoading(false);
        }

        updateProducts();
    }, [searchArticle, selectedSegments, selectedCategories, selectedFamilies, currentPage, pageSize, localMarketId, articlesStock, articlesTransit])

    useEffect(() => {
        //console.log(prevSelectedSegments?.current, selectedSegments);
        if (data?.items && data?.items.length > 0 && prevSelectedSegments?.current !== selectedSegments) {
            getCategoriesBySelectedSegments(selectedSegments, data?.items);

            prevSelectedSegments.current = selectedSegments;
        }

        if (data?.items && data?.items.length > 0 && prevSelectedSegmentCategories?.current !== selectedSegmentCategories) {
            getFamiliesBySelectedCategories(selectedSegmentCategories, data?.items);

            prevSelectedSegmentCategories.current = selectedSegmentCategories;
        }
    }, [data?.items, selectedSegmentCategories, selectedSegments]);

    const fetchCategoriesBySegment = async (segmentId: number) => {
        try {
            const body = {
                advancedFilter: {
                    logic: "and",
                    filters: [
                        {
                            filters: [
                                {
                                    field: "segmentId",
                                    operator: "eq",
                                    value: segmentId
                                }
                            ],
                            logic: "or"
                        }
                    ],
                    field: "marketId",
                    operator: "eq",
                    value: Number(localMarketId)
                },
                pageNumber: 1,
                pageSize: 50
            };

            const response = await ApiHttpClient().post('/hierarchyLocal/search', body);

            if (response?.data?.items) {
                const uniqueCategoriesMap = new Map();
                response.data.items.forEach((item: any) => {
                    if (!uniqueCategoriesMap.has(item.categoryLabel)) {
                        uniqueCategoriesMap.set(item.categoryLabel, {
                            categoryId: item.categoryId,
                            categoryLabel: item.categoryLabel
                        });
                    }
                });

                setSegmentCategories(prev => ({
                    ...prev,
                    [segmentId]: Array.from(uniqueCategoriesMap.values())
                }));
            }
        } catch (error) {
            console.error('Eroare la preluarea categoriilor:', error);
            toast({description: 'Eroare la preluarea categoriilor'});
        }
    };

    const handleCategoryClick = (categoryId: number) => {
        const isSelected = selectedCategories.includes(categoryId);
        let newSelectedCategories;

        if (isSelected) {
            newSelectedCategories = selectedCategories.filter(id => id !== categoryId);

            setCategoryFamilies(prev => {
                const copy = { ...prev };
                const removedFamilies = copy[categoryId]?.map(f => f.familyId) || [];

                setSelectedFamilies(prevFamilies => {
                    const updated = { ...prevFamilies };

                    if (updated[categoryId]) {
                        updated[categoryId] = updated[categoryId].filter(famId => !removedFamilies.includes(famId));
                        if (updated[categoryId].length === 0) delete updated[categoryId];
                    }

                    return updated;
                });

                delete copy[categoryId];
                return copy;
            });

        } else {
            newSelectedCategories = [...selectedCategories, categoryId];
            fetchFamiliesByCategory(categoryId);
        }

        setSelectedCategories(newSelectedCategories);

    };

    const fetchFamiliesByCategory = async (categoryId: number) => {
        try {
            const body = {
                advancedFilter: {
                    logic: "and",
                    filters: [
                        {
                            filters: [
                                {
                                    field: "categoryId",
                                    operator: "eq",
                                    value: categoryId
                                }
                            ],
                            logic: "or"
                        }
                    ],
                    field: "marketId",
                    operator: "eq",
                    value: Number(localMarketId)
                },
                pageNumber: 1,
                pageSize: 50
            };

            const response = await ApiHttpClient().post('/hierarchyLocal/search', body);

            if (response?.data?.items) {
                const uniqueFamiliesMap = new Map();
                response.data.items.forEach((item: any) => {
                    if (!uniqueFamiliesMap.has(item.familyLabel)) {
                        uniqueFamiliesMap.set(item.familyLabel, {
                            familyId: item.familyId,
                            familyLabel: item.familyLabel,
                        });
                    }
                });

                setCategoryFamilies(prev => ({
                    ...prev,
                    [categoryId]: Array.from(uniqueFamiliesMap.values())
                }));
            }
        } catch (error) {
            console.error('Eroare la preluarea familiilor:', error);
            toast({ description: 'Eroare la preluarea familiilor' });
        }
    };

    const handleFamilyClick = (categoryId: number, familyId: number) => {
        setSelectedFamilies(prev => {
            const current = prev[categoryId] || [];
            const updated = current.includes(familyId)
                ? current.filter(id => id !== familyId)
                : [...current, familyId];
            return { ...prev, [categoryId]: updated };
        });
    };
    
    const currentCategoryName = categories.find(cat => cat.localMarketId === localMarketId);

    const handleShowArticlesTransit = () => {
        setArticlesTransit(true);
        setArticlesStock(false);
        setCurrentPage(0);
    }

    const handleShowArticlesStock = () => {
        setArticlesStock(true);
        setArticlesTransit(false);
        setCurrentPage(0);
    }

    const handleRemoveFilters = () => {
        setArticlesStock(false);
        setArticlesTransit(false);
        setCurrentPage(0);
    }

    return (
        <>
            <Navbar/>
            <div className="max-w-[1640px] m-auto px-4 py-12">
                <h2 className="text-xl text-center font-bold text-gray-900 my-3 sm:text-3xl">Categorii
                    recomandate
                </h2>
                <div className="">
                    <div className="flex items-center justify-center">
                        <div
                            className="grid grid-cols-2 justify-stretch lg:grid-cols-5 place-items-left gap-1 py-3 md:px-6 w-4/5">

                            {categories.map((item, index) => (

                                index < 10 && (
                                    <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                                        <a href={"/category/" + item.localMarketId}>
                                            <button
                                                id={`dropdownAvatarNameButton-${item.id}`}
                                                onClick={() => toggleDropdown(index)}
                                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                                type="button"
                                                style={{zIndex: 1}}
                                            >
                                                <span className="sr-only">Open user menu</span>
                                                <img className="w-12 h-12 me-2 rounded-full" src={item.image}
                                                     alt={item.name}/>
                                                {item.name}
                                            </button>
                                        </a>
                                    </div>
                                )
                            ))}

                        </div>
                    </div>
                    <hr className="h-px mx-6 bg-gray-300 border-0 dark:bg-gray-700"></hr>

                    <div className="flex items-center justify-center">
                        <div className="grid grid-cols-2 lg:grid-cols-4 place-items-left gap-1 py-3 md:px-6 w-3/4">
                            {categories.map((item, index) => (

                                index > 9 && index < 18 && (
                                    <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                                        <a href={"/category/" + item.localMarketId}>
                                            <button
                                                id={`dropdownAvatarNameButton-${item.id}`}
                                                onClick={() => toggleDropdown(index)}
                                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                                type="button"
                                                style={{zIndex: 1}}
                                            >
                                                <span className="sr-only">Open user menu</span>
                                                <img className="w-12 h-12 me-2 rounded-full" src={item.image}
                                                     alt={item.name}/>
                                                {item.name}
                                            </button>
                                        </a>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>

                    <hr className="h-px mx-6 bg-gray-200 border-0 dark:bg-gray-700"></hr>
                    <div className="flex items-center justify-center">
                        <div className="grid grid-cols-2 lg:grid-cols-3 place-items-left gap-1 py-3 w-3/4 md:w-1/2">
                            {categories.map((item, index) => (

                                index > 17 && (
                                    <div key={index} style={{position: 'relative'}} className="mx-1 md:mx-2">
                                        <a href={"/category/" + item.localMarketId}>
                                            <button
                                                id={`dropdownAvatarNameButton-${item.id}`}
                                                onClick={() => toggleDropdown(index)}
                                                className="flex items-center text-sm text-left pe-1 font-medium text-gray-900 rounded-full hover:text-red-600 dark:hover:text-red-500 md:me-0 focus:ring-4 focus:ring-gray-100 dark:focus:ring-gray-700 dark:text-white"
                                                type="button"
                                                style={{zIndex: 1}}
                                            >
                                                <span className="sr-only">Open user menu</span>
                                                <img className="w-12 h-12 me-2 rounded-full" src={item.image}
                                                     alt={item.name}/>
                                                {item.name}
                                            </button>
                                        </a>
                                    </div>
                                )
                            ))}
                        </div>
                    </div>
                </div>

                <section>
                    <div className="mx-auto text-center max-w-screen-xl px-4 py-8 sm:px-6 sm:py-2 lg:px-8">
                        <header>
                            <h2 className="text-xl font-bold mt-4 mb-4 text-gray-900 my-3 sm:text-3xl">
                                {loading ? (
                                    <LoadingElement/>
                                ) : (data?.items && data?.items?.length > 0) ? (
                                    currentCategoryName?.name
                                ) : (
                                    <div className="text-center">
                                        Momentan nu exista produse disponibile in aceasta categorie.
                                    </div>
                                )}
                            </h2>

                            {data?.items.length && data?.items.length > 0 && articlesStock && !atacFlowUser ?
                                <h2 className="text-xl font-bold mt-4 mb-4 text-gray-900 my-3 sm:text-3xl">Produse cu
                                    stoc</h2> : ""}
                            {data?.items.length && data?.items.length > 0 && articlesTransit && !atacFlowUser ?
                                <h2 className="text-xl font-bold mt-4 mb-4 text-gray-900 my-3 sm:text-3xl">Produse cu
                                    livrare programata</h2> : ""}
                        </header>
                    </div>
                </section>

                <div
                    className="mt-1 sm:flex sm:items-center sm:justify-between max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-2 lg:px-8">
                    <div className="mt-6 sm:flex sm:items-center sm:flex-row space-x-3 mb-4">
                        {categories.find(c => c.localMarketId === Number(localMarketId))?.subcategories?.map((segment, index) => (
                            <div key={index}>
                                <button
                                    className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-sm whitespace-nowrap ${
                                        selectedSegments.includes(segment.segmentId)
                                            ? 'bg-red-600 text-white'
                                            : 'bg-red-100 text-red-600'
                                    }`}
                                    onClick={() => handleSegmentFilter(segment.segmentId)}
                                >
                                    <p className="text-sm whitespace-nowrap">{segment.segmentName}</p>
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <div
                    className="mt-1 sm:flex sm:items-center sm:justify-between max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-2 lg:px-8">
                    <div className="flex flex-wrap gap-2">
                        {Object.values(segmentCategories).flat().map(cat => (
                            <button
                                key={cat.categoryId}
                                className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-sm ${
                                    selectedCategories.includes(cat.categoryId)
                                        ? 'bg-red-700 text-white'
                                        : 'bg-red-200 text-red-700'
                                }`}
                                onClick={() => handleCategoryClick(cat.categoryId)}
                            >
                                {cat.categoryLabel}
                            </button>
                        ))}
                    </div>
                </div>

                <div
                    className="mt-1 sm:flex sm:items-center sm:justify-between max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-2 lg:px-8">
                    <div className="flex flex-wrap gap-2">
                        {Object.entries(categoryFamilies).map(([catIdStr, fams]) =>
                            fams.map(fam => {
                                const catId = Number(catIdStr);
                                return (
                                    <button
                                        key={fam.familyId}
                                        className={`inline-flex items-center justify-center rounded-full px-2.5 py-0.5 text-sm ${
                                            selectedFamilies[catId]?.includes(fam.familyId)
                                                ? 'bg-red-800 text-white'
                                                : 'bg-red-300 text-red-800'
                                        }`}
                                        onClick={() => handleFamilyClick(catId, fam.familyId)}
                                    >
                                        {fam.familyLabel}
                                    </button>
                                );
                            })
                        )}

                    </div>
                </div>

                {((data?.items.length && data?.items.length > 0) || searchArticle) &&
                    <div className="max-w-[1320px] m-auto px-4 mt-1 py-0 sm:px-6 sm:py-2 lg:px-8">
                        <SearchInput setSearchArticle={setSearchArticle}/>
                    </div>}

                {!userUM && !atacFlowUser && data?.items && data?.items?.length > 0 && <div
                    className="mt-1 sm:flex sm:items-center sm:justify-between max-w-screen-xl mx-auto px-4 py-8 sm:px-6 sm:py-2 lg:px-8">
                    <div className="mt-6 sm:flex sm:items-center sm:flex-row space-x-3 mb-4">
                        <button
                            className="inline-flex items-center justify-center rounded-full bg-emerald-100 px-2.5 py-0.5 text-emerald-700"
                            onClick={handleShowArticlesStock}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="-ms-1 me-1.5 size-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M9 12.75L11.25 15 15 9.75M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                                />
                            </svg>

                            <p className="text-sm whitespace-nowrap">Produse cu stoc</p>
                        </button>

                        <button
                            className="inline-flex items-center justify-center rounded-full bg-amber-100 px-2.5 py-0.5 text-amber-700"
                            onClick={handleShowArticlesTransit}
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="1.5"
                                stroke="currentColor"
                                className="-ms-1 me-1.5 size-4"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M8.25 9.75h4.875a2.625 2.625 0 010 5.25H12M8.25 9.75L10.5 7.5M8.25 9.75L10.5 12m9-7.243V21.75l-3.75-1.5-3.75 1.5-3.75-1.5-3.75 1.5V4.757c0-1.108.806-2.057 1.907-2.185a48.507 48.507 0 0111.186 0c1.1.128 1.907 1.077 1.907 2.185z"
                                />
                            </svg>

                            <p className="text-sm whitespace-nowrap">Livrare programata</p>
                        </button>
                    </div>

                    <button
                        className="inline-flex items-center justify-center rounded-full bg-gray-100 px-2.5 py-0.5 text-gray-700"
                        onClick={handleRemoveFilters}
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke-width="1.5"
                            stroke="currentColor"
                            className="size-3"
                        >
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12"/>
                        </svg>

                        <p className="text-sm whitespace-nowrap ml-2">Elimina filtrele</p>
                    </button>
                </div>}

                {(data?.items && data?.items?.length > 0) ? <div className="flex mx-auto max-w-[1320px] gap-4 m-auto px-4 mt-1 py-0 sm:px-6 sm:py-2 lg:px-8">
                    <p className="flex justify-center mt-2">Afisare: </p>
                    <span className="inline-flex overflow-hidden rounded-md border bg-white shadow-sm">
                        
                        <button
                            className="inline-block border-e p-3 text-gray-700 hover:bg-gray-50 focus:relative"
                            title="Afisare multipla"
                            onClick={showMultiply}
                            style={{backgroundColor: isMultiple ? "white" : "#D3D3D3"}}
                        >
                            <BiSolidGridAlt/>
                        </button>

                        <button
                            className="inline-block border-e p-3 text-gray-700 hover:bg-gray-50 focus:relative"
                            title="Afisare tabelara"
                            onClick={showTable}
                            style={{
                                backgroundColor: isTabular ? "white" : "#D3D3D3",
                            }}
                        >
                            <CiViewTable/>
                        </button>
                    </span>
                </div> : ""}

                {isMultiple && (
                    <section>
                        <div className="mx-auto mt-1 max-w-screen-2xl px-0 py-0 sm:px-6 sm:py-2 lg:px-8">
                            <ul className="mt-4 grid gap-1 sm:grid-cols-5 lg:grid-cols-5">
                                {data?.items.map((article: ArticleModel) => {
                                    let product = mapArticleModelToProductData(article);
                                    return (
                                        <li key={product.id}>
                                            <div className="p-1 text-center">
                                                <ProductCard productData={product} autoPlayCarousel={false}/>
                                            </div>
                                        </li>
                                    );
                                })}
                            </ul>
                        </div>
                    </section>
                )}

                {(data?.items.length && data?.items.length > 0) && isTabular ? (<section>
                    <div className="max-w-[1320px] m-auto px-4 mt-1 py-0 sm:px-6 sm:py-2 lg:px-8">
                        <div className="relative overflow-auto" style={{maxHeight: '780px'}}>

                            <table className="w-full border-collapse">
                                <thead>
                                <tr className="bg-white border-slate-200">
                                    <th className="sticky top-0 bg-white z-10 text-left p-2 text-gray-500 text-sm">Cod
                                        articol
                                    </th>
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">Imagine</th>
                                    <th className="top-0 left-0 sticky bg-white z-20 text-gray-500 text-sm text-center whitespace-normal">Denumire <br/> articol
                                    </th>
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">UM</th>
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">Unitatea
                                        de vanzare
                                    </th>
                                    {!atacFlowUser &&
                                        <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">
                                            Pret UM cu <span className="text-blue-900">TVA inclus</span>
                                        </th>}
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">
                                        Pret pe unitate de vanzare <span
                                        className="text-blue-900">fara TVA</span>
                                    </th>
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">
                                        Pret pe unitate de vanzare cu <span
                                        className="text-blue-900">TVA inclus</span>
                                    </th>
                                    {/* <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">Taxe si Garantii</th> */}
                                    <th className="sticky top-0 bg-white z-10 text-center p-2 text-gray-500 text-sm">
                                        Unitati de vanzare comandate / <br/> Total UM comandat
                                    </th>
                                </tr>
                                </thead>
                                <TableBody>
                                    {data.items?.length > 0 && data.items.map((article: ArticleModel, index: number) => {
                                        let product = mapArticleModelToProductData(article);
                                        return (
                                            <TableRow key={product.id}
                                                      className={index % 2 === 0 ? "bg-slate-150" : "bg-slate-100"}>
                                                <TableCell>
                                                    {!userUM && product.isTransit ?
                                                        <div className="flex flex-row">
                                                            <div
                                                                className="group relative m-2 flex justify-left">
                                                                <div
                                                                    className="h-2.5 w-2.5 rounded-full bg-yellow-500 me-2"></div>
                                                                <span
                                                                    className="absolute top-4 scale-0 z-50 rounded bg-gray-800 p-2 text-xs text-white group-hover:scale-100">✨ Livrare programata</span>
                                                            </div>

                                                            {product.id}
                                                        </div> : <div>{product.id}</div>}
                                                </TableCell>
                                                <TableCell>
                                                    {product.articleImage?.mainLink &&
                                                        <img src={product.articleImage?.mainLink} alt={"test"}
                                                             className="size-16"/>
                                                    }
                                                    {!product.articleImage?.mainLink &&
                                                        <img src={noImageAvailable} alt={"test"}
                                                             className="size-20"/>
                                                    }
                                                </TableCell>
                                                {userUM ?
                                                    <TableCell
                                                        className={index % 2 === 0 ? "bg-white sticky left-0 z-10 font-medium w-[150px]" : "bg-slate-100 sticky left-0 z-10 font-medium w-[100px]"}>
                                                        {language === "romana" &&
                                                            <a href={"/product/" + product.id}
                                                               className="group relative block overflow-hidden text-left"
                                                            >{product?.displayName}</a>}
                                                        {language === "franceza" && product?.longNameFR === null &&
                                                            <a href={"/product/" + product.id}
                                                               className="group relative block overflow-hidden text-left"
                                                            >{product?.displayName}</a>}
                                                        {language === "franceza" && product?.longNameFR !== null &&
                                                            <a href={"/product/" + product.id}
                                                               className="group relative block overflow-hidden text-left"
                                                            >{product?.longNameFR}</a>}
                                                    </TableCell> : <TableCell
                                                        className={index % 2 === 0 ? "bg-white sticky left-0 z-10 font-medium w-[150px]" : "bg-slate-100 sticky left-0 z-10 font-medium w-[100px]"}>
                                                        <a href={"/product/" + product.id}
                                                           className="group relative block overflow-hidden text-left text-wrap"
                                                        >{product.displayName}</a>
                                                    </TableCell>}
                                                <TableCell>{product.salesUnit === 'A' &&
                                                    <p>Bucata</p>} {product.salesUnit === 'K' &&
                                                    <p>Kilogram</p>} {product.salesUnit === 'M' &&
                                                    <p>Metru</p>}</TableCell>
                                                <TableCell>{product.multiplier}</TableCell>
                                                {!atacFlowUser &&
                                                    <TableCell>{product.priceWithVAT1.toFixed(2)} RON</TableCell>}
                                                {!atacFlowUser &&
                                                    <TableCell>{product.unitPrice1.toFixed(2)} RON</TableCell>}
                                                {!atacFlowUser &&
                                                    <TableCell>{product.unitPriceWithVAT1.toFixed(2)} RON</TableCell>}
                                                {atacFlowUser && <TableCell>
                                                    <div className="flex-col">
                                                        <div className="">{product.multiplier}+ <span
                                                            className="text-red-500 ml-3">{product.unitPrice1.toFixed(2)} RON</span>
                                                        </div>
                                                        {product.thresholdPrice2 &&
                                                            <div
                                                                className="">{product.thresholdQuantity2}+ <span
                                                                className="text-red-600 ml-3">{product.unitPrice2.toFixed(2)} RON</span>
                                                            </div>}
                                                        {product.thresholdPrice3 &&
                                                            <div
                                                                className="">{product.thresholdQuantity3}+ <span
                                                                className="text-red-700 ml-3">{product.unitPrice3.toFixed(2)} RON</span>
                                                            </div>}
                                                    </div>
                                                </TableCell>}
                                                {atacFlowUser && <TableCell>
                                                    <div className="flex-col">
                                                        <div className="">{product.multiplier}+ <span
                                                            className="text-red-500 ml-3">{product.unitPriceWithVAT1.toFixed(2)} RON</span>
                                                        </div>
                                                        {product.thresholdPrice2 &&
                                                            <div
                                                                className="">{product.thresholdQuantity2}+ <span
                                                                className="text-red-600 ml-3">{product.unitPriceWithVAT2.toFixed(2)} RON</span>
                                                            </div>}
                                                        {product.thresholdPrice3 &&
                                                            <div
                                                                className="">{product.thresholdQuantity3}+ <span
                                                                className="text-red-700 ml-3">{product.unitPriceWithVAT3.toFixed(2)} RON</span>
                                                            </div>}
                                                    </div>
                                                </TableCell>}
                                                {/*<TableCell>{product.unitPriceWithVAT} RON</TableCell>*/}
                                                {/* <TableCell>{product.taxArticles && product.taxArticles.tax?.activeTaxPrice ? product.taxArticles.tax.activeTaxPrice?.taxPriceValue : '-'} RON</TableCell> */}
                                                <TableCell className="text-center">
                                                    <div className="text-center">
                                                        <div key={product.id}>
                                                            <ProductTable
                                                                productData={product}
                                                                key={product.id}
                                                                horziontal={true}
                                                            />
                                                        </div>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </table>
                        </div>
                    </div>
                </section>) : (
                    searchArticle && (
                        <div className="text-center mt-8">
                            {data?.totalPages === 0 && <p>Nu au fost gasite rezultate.</p>}
                        </div>
                    )
                )}

                {(data?.items.length && data?.items.length > 0) ? (<div className="text-center mb-4">
                    <ul className="flex justify-center gap-1 text-gray-900 mt-3">
                        <li>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage > 0) handlePageChange(currentPage - 1);
                                }}
                                className="grid mr-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                aria-label="Previous page"
                                disabled={currentPage === 0}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="size-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M12.707 5.293a1 1 0 010 1.414L9.414 10l3.293 3.293a1 1 0 01-1.414 1.414l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>

                        <li>
                            <label htmlFor="Page" className="flex items-center gap-1">
                                <span className="sr-only">Pagina</span>
                                <input
                                    type="number"
                                    id="Page"
                                    value={inputValue}
                                    min={1}
                                    max={data.totalPages}
                                    onChange={handleInputChange}
                                    className="h-8 w-10 rounded border-gray-300 text-center sm:text-sm"
                                />
                                <span className="text-sm">/ {data.totalPages}</span>
                            </label>
                        </li>

                        <li>
                            <button
                                onClick={(e) => {
                                    e.preventDefault();
                                    if (currentPage < data.totalPages - 1) handlePageChange(currentPage + 1);
                                }}
                                className="grid ml-2 size-8 place-content-center rounded border border-gray-200 transition-colors hover:bg-gray-50 rtl:rotate-180"
                                aria-label="Next page"
                                disabled={currentPage === data.totalPages - 1}
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    className="size-4"
                                    viewBox="0 0 20 20"
                                    fill="currentColor"
                                >
                                    <path
                                        fillRule="evenodd"
                                        d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                        clipRule="evenodd"
                                    />
                                </svg>
                            </button>
                        </li>
                    </ul>
                </div>) : ''}

            </div>

            {process.env.REACT_APP_SHOW_MAINTENANCE_NOTIFICATION === 'true' &&
                <div className="fixed inset-x-0 bottom-0 p-4 z-20">
                    <div className="rounded-lg bg-red-600 px-4 py-3 text-white shadow-lg">
                        <p className="text-center text-sm font-medium">
                            {process.env.REACT_APP_MAINTENANCE_MESSAGE}
                        </p>
                    </div>
                </div>}
            <Footer/>
        </>
    );
}

export default CategoryList;
